import { FlexBox } from "@braze/beacon-core";
import styled from "styled-components";

export const FormContainer = styled(FlexBox)`
width: 100%;
display: flex;
flex-direction: column;
.bcl-number-input {
    width: 100%;
}
`